






















































































































import { Vue, Component } from 'vue-property-decorator';
import AMSDialog from '@/components/AMSDialog.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import { AppStore } from '@/store/modules/app';
import { rangeRule, emptyRule } from '@/utils/rules';
import { deleteCustomerLevel, addOrEditCustomerLevel, customerLevelList } from '@/api/customer';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';

interface CustomerLevelModel {
  id: string;
  name: string;
  discount: string;
  description: string;
  isStatic: boolean;
}

@Component({
  components: {
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class CustomerLevel extends Vue {
  /**面包屑 */
  breadItems = [
    {
      text: '系统设置',
      disabled: false,
      href: 'customerLevel'
    },
    {
      text: '客户等级',
      disabled: true
    }
  ];
  /**弹窗配置 */
  dialogWidth: number = 500;
  showDialog: boolean = false;
  /**是否是删除状态 */
  isDelete: boolean = false;

  /**用户名规则 */
  nameRules: Array<any> = [emptyRule('等级名称')];

  currentItem: CustomerLevelModel = {
    id: '',
    name: '',
    discount: '',
    description: '',
    isStatic: false
  };

  defaultItem: CustomerLevelModel = {
    id: '',
    name: '',
    discount: '100',
    description: '',
    isStatic: false
  };

  header: any = [
    { text: '等级名称', align: 'left', value: 'name', sortable: false },
    // { text: '折扣', align: 'center', value: 'discount', sortable: false },
    { text: '描述', align: 'left', value: 'description', sortable: false },
    this.getPermission('SystemSettings.CustomerLevel.CreateOrEdit') || this.getPermission('SystemSettings.CustomerLevel.Delete')
      ? { text: '操作', align: 'center', value: 'action', sortable: false }
      : {}
  ];
  items: CustomerLevel[] = [];
  requestLoading: boolean = false;
  created() {
    this.getCustomerLevelList();
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  get dialogTitle() {
    return this.isDelete ? '提示' : '客户等级';
  }

  /**折扣规则 */
  get discountRules() {
    const rules = [];
    if (this.currentItem.discount) {
      rules.push(rangeRule(28.0, 100.0, '%', '等级折扣'));
      // let v = this.currentItem.discount.match(/^\d*(\.?\d{0,8})/g);
      // console.log(v)
      // if (isNaN(parseFloat(this.currentItem.discount))) {
      //   rules.push((v: any) => {
      //     return '格式错误';
      //   });
      // } else {
      //   rules.push(rangeRule(28.0, 100.0, '%', '等级折扣'));
      // }
    } else {
      rules.push(emptyRule('等级折扣'));
    }
    return rules;
  }

  /**监听折扣输入事件 */
  onDiscountInput(value: string) {
    //折扣数字长度不能超过8位，允许有2位小数点，小数点2位以后的自动四舍五入
    //let v = value.match(/^\d*(\.?\d{0,2})/g);
    let v = value.match(/^\d*(\.?\d{0,8})/g);
    if (v != null && v.length == 1 && v[0] == '') {
      this.$nextTick(() => {
        this.currentItem.discount = '';
      });
    } else {
      if (v != null && v.length > 0) {
        let s = v[0];
        this.$nextTick(() => {
          if (parseFloat(s) <= 0) {
            this.currentItem.discount = '';
          } else {
            let i = s.indexOf('.');
            if (i != -1) {
              let strs = s.split('.');
              let last = strs[strs.length - 1];
              if (last.length > 2) {
                this.currentItem.discount = parseFloat(s).toFixed(2);
              } else {
                this.currentItem.discount = s; //parseFloat(s).toFixed(2)
              }
            }
          }
        });
      } else {
        console.log('格式有问题');
      }
    }
  }

  /**监听等级名称输入事件 */
  onNameInput(value: string) {
    // this.$nextTick(() => {
    // let v = value;
    // v = v.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g, '');
    // v = v.trim();
    // if (v.length <= 20) {
    //   this.currentItem.name = v;
    // } else {
    //   this.currentItem.name = v.substring(0, 20);
    // }
    // this.currentItem.name = v;
    // });
  }

  /**点击新增 */
  onAddClick() {
    this.currentItem = Object.assign({}, this.defaultItem);
    this.isDelete = false;
    // (this.$refs.form as any).reset()
    (this.$refs.form as any).resetValidation();
    this.showDialog = true;
  }

  /**点击编辑按钮 */
  onEditClick(item: CustomerLevelModel) {
    (this.$refs.form as any).resetValidation();
    this.currentItem = Object.assign({}, item);
    this.isDelete = false;
    this.showDialog = true;
  }

  /**点击删除按钮 */
  onDeleteClick(item: CustomerLevelModel) {
    this.currentItem = Object.assign({}, item);
    this.isDelete = true;
    this.showDialog = true;
  }

  /**点击了取消 */
  close() {
    this.showDialog = false;
  }

  /**点击了提交按钮 */
  submit(stop: Function) {
    // 删除
    if (this.isDelete) {
      this.requestLoading = true;
      deleteCustomerLevel(this.currentItem.id)
        .then((response: any) => {
          AppStore.ShowSuccess('删除客户等级成功');
          this.getCustomerLevelList();
          this.showDialog = false;
        })
        .finally(() => {
          stop();
          this.requestLoading = false;
        })
        .catch((error: any) => {
          stop();
          this.requestLoading = false;
        });
    }
    //编辑或者新增
    else {
      if ((this.$refs.form as any).validate()) {
        this.requestLoading = true;
        addOrEditCustomerLevel(this.currentItem)
          .then((response: any) => {
            this.requestLoading = false;
            AppStore.ShowSuccess(this.currentItem.id != '' && this.currentItem.id != undefined ? '修改客户等级成功' : '创建客户等级成功');
            this.getCustomerLevelList();
            this.showDialog = false;
          })
          .finally(() => {
            stop();
            this.requestLoading = false;
          })
          .catch((error: any) => {
            stop();
            this.requestLoading = false;
            this.showDialog = false;
          });
      } else {
        stop();
      }
    }
  }

  /**获取客户等级列表 */
  getCustomerLevelList() {
    customerLevelList()
      .then((response: any) => {
        this.items = [];
        let array: CustomerLevel[] = response.items;
        this.items = array;
      })
      .catch((error: any) => {
        // AppStore.ShowError(error);
      });
  }
}
